// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.twA0E3FaoQwfLXSGzHRt {
    padding: 16px;
    display: grid;
    grid-template-columns: 0.5fr 0.5fr 0.5fr 0.5fr 1.25fr;
    column-gap: 24px;
    overflow-y: hidden;
    overflow-x: scroll;
    scrollbar-color: rgba(0, 0, 0, 0.1) transparent; /* thumb and track color */
    scrollbar-width: thin;
    align-items: center;
}

.twA0E3FaoQwfLXSGzHRt::-webkit-scrollbar {
    height: 4px;  /* for vertical scrollbars */
}

.twA0E3FaoQwfLXSGzHRt::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
}

._C1ofz5oXF9lNrbvUu8r {
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.M9ZwdxaXJxXOuI0fHyvz {
    padding: 16px;
    border-bottom: 1px solid #E5E5E5;
}

.oHYzfCERPy1Lw4I5Qapi p {
    margin: 0;
}


.bYWVC3zymsnHlxJFAG7x {
    border: 1px solid #E5E5E5;
    border-radius: 5px;

    display: flex;
    align-items: center;
}

.bYWVC3zymsnHlxJFAG7x input {
    width: 100%;
    height: 100%;
    padding: 8px;
    border: none;
    outline: none;
}

.OLMRs8mpf8Mp4Cetfdj5 {
    margin-left: 8px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
}

.vITwQpQTIoJYaA5gGMzg {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};

    display: flex;
    align-items: center;

    transition: .3s;
}

.vITwQpQTIoJYaA5gGMzg:hover {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.LZS4m_S8ffE_MdrHuCiU {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    margin-top: 0;
}

.zin3pnYq25GRepmehzCa {
    text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardOpportunity/DashboardOpportunityToolbar/DashboardOpportunityToolbar.module.css"],"names":[],"mappings":"AAGA;IACI,aAAa;IACb,aAAa;IACb,qDAAqD;IACrD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,+CAA+C,EAAE,0BAA0B;IAC3E,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW,GAAG,4BAA4B;AAC9C;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,SAAS;AACb;;;AAGA;IACI,yBAAyB;IACzB,kBAAkB;;IAElB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mDAAwB;AAC5B;;AAEA;IACI,mDAAwB;;IAExB,aAAa;IACb,mBAAmB;;IAEnB,eAAe;AACnB;;AAEA;IACI,mDAAmB;AACvB;;AAEA;IACI,mDAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["@value colors: \"../../../../components/library/style/colors.css\";\n@value color-text-subtle, color-purple from colors;\n\n.grid {\n    padding: 16px;\n    display: grid;\n    grid-template-columns: 0.5fr 0.5fr 0.5fr 0.5fr 1.25fr;\n    column-gap: 24px;\n    overflow-y: hidden;\n    overflow-x: scroll;\n    scrollbar-color: rgba(0, 0, 0, 0.1) transparent; /* thumb and track color */\n    scrollbar-width: thin;\n    align-items: center;\n}\n\n.grid::-webkit-scrollbar {\n    height: 4px;  /* for vertical scrollbars */\n}\n\n.grid::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n}\n\n.container {\n    background-color: white;\n    border-radius: 5px;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\n}\n\n.toolbar {\n    padding: 16px;\n    border-bottom: 1px solid #E5E5E5;\n}\n\n.search p {\n    margin: 0;\n}\n\n\n.inputContainer {\n    border: 1px solid #E5E5E5;\n    border-radius: 5px;\n\n    display: flex;\n    align-items: center;\n}\n\n.inputContainer input {\n    width: 100%;\n    height: 100%;\n    padding: 8px;\n    border: none;\n    outline: none;\n}\n\n.icon {\n    margin-left: 8px;\n    color: color-text-subtle;\n}\n\n.clear {\n    color: color-text-subtle;\n\n    display: flex;\n    align-items: center;\n\n    transition: .3s;\n}\n\n.clear:hover {\n    color: color-purple;\n}\n\n.title {\n    color: color-text-subtle;\n    margin-top: 0;\n}\n\n.number {\n    text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../../components/library/style/colors.css"`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"grid": `twA0E3FaoQwfLXSGzHRt`,
	"container": `_C1ofz5oXF9lNrbvUu8r`,
	"toolbar": `M9ZwdxaXJxXOuI0fHyvz`,
	"search": `oHYzfCERPy1Lw4I5Qapi`,
	"inputContainer": `bYWVC3zymsnHlxJFAG7x`,
	"icon": `OLMRs8mpf8Mp4Cetfdj5`,
	"clear": `vITwQpQTIoJYaA5gGMzg`,
	"title": `LZS4m_S8ffE_MdrHuCiU`,
	"number": `zin3pnYq25GRepmehzCa`
};
export default ___CSS_LOADER_EXPORT___;
